import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import auth from '@lcai/console-auth';
import fetcher from '@lcai/console-fetcher-base';
export default function dataAuthLogout() {
  return _dataAuthLogout.apply(this, arguments);
}
function _dataAuthLogout() {
  _dataAuthLogout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _auth, token, tenantId;
    return _regeneratorRuntime().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _auth = auth(), token = _auth.token, tenantId = _auth.tenantId;
          _context.next = 1;
          return fetcher.post({
            headers: {
              // 这里和 console-fetcher 下有些重叠，但没办法
              'Tenant-Id': tenantId,
              Authorization: "Bearer ".concat(token)
            }
          }, '/system/auth/logout');
        case 1:
          auth.update('token', '');
          window.postMessage({
            type: 'lcai.console.logout'
          }, location.href);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _dataAuthLogout.apply(this, arguments);
}
//# sourceMappingURL=data-auth-logout.js.map